// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EWptYUU9xcT6KY {
  position: relative;
  flex-basis: min-content;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 20px;
}
.zqX97vZm1OY5vJ {
  order: 1;
  min-height: 0;
}
.b4Keujk7X4O23A {
  margin: var(--ds-space-0, 0);
}
._kx6W7TgeWyn4y {
  z-index: 0;
  width: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px) var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  background-color: transparent;
  color: var(--accent-text-bolder, var(--ds-text, #172b4d));
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 20px;
  text-align: left;
  white-space: normal;
  cursor: pointer;
  overflow-wrap: anywhere;
}
.GJoHRLVAUQGqpY {
  cursor: auto;
}
.zqX97vZm1OY5vJ ._kx6W7TgeWyn4y {
  padding: var(--ds-space-050, 4px);
  line-height: 1em;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
._kx6W7TgeWyn4y[hidden] {
  display: none;
}
.h3iSNmIaIueSDt {
  display: flex;
  padding: var(--ds-space-0, 0);
}
.jPlpB5pt2sAcMv {
  font-size: 12px;
  font-style: italic;
}
.oTZCBVwh2Ud4al {
  position: absolute;
  z-index: -1;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  box-sizing: border-box;
  min-height: 20px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-100, 8px) var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  opacity: 0;
  background: transparent;
  box-shadow: none;
  font-weight: var(--ds-font-weight-semibold, 600);
  resize: none;
  overflow-wrap: break-word;
}
.gBaO4IEjdu6twf {
  display: block;
  position: static;
  z-index: 0;
  box-sizing: border-box;
  width: 100%;
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  outline: none;
  opacity: 1;
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
  /* Focus State */
}
.gBaO4IEjdu6twf:focus {
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
export var container = `EWptYUU9xcT6KY`;
var _1 = `zqX97vZm1OY5vJ`;
export { _1 as "container--collapsed" };
export var heading = `b4Keujk7X4O23A`;
export var listName = `_kx6W7TgeWyn4y`;
var _2 = `GJoHRLVAUQGqpY`;
export { _2 as "listName--disabled" };
export var ListNameText = `h3iSNmIaIueSDt`;
export var listId = `jPlpB5pt2sAcMv`;
export var listNameTextarea = `oTZCBVwh2Ud4al`;
var _3 = `gBaO4IEjdu6twf`;
export { _3 as "listNameTextarea--editing" };
export default ___CSS_LOADER_EXPORT___;
